import { MouseEvent } from "react";
import Button, { ButtonSizeEnum, ButtonTypeEnum } from "../atoms/Button";

export const SignInBtn = ({
  text,
  onClick,
}: {
  text: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
}) => {
  return (
    <Button
      type={ButtonTypeEnum.Secondary}
      size={ButtonSizeEnum.Small}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
